


























































































































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import camelcase from 'lodash.camelcase';
import { Utilities } from "../../../shared/utilities";
import hotkeys from "./HotKeys/HotKeys.vue";
import autocmplete from "vuejs-auto-complete";
import * as _ from "lodash";
import header from "./Card/Header/Header.vue";
import document from "./Document/Document.vue";
import { http } from "@/shared/https";

/*
 * Component's variables
 */
let components = {};
let menuId = Utilities.getParameterByName("mId");
const requireModule = require.context("./../Modules", true, /\.vue$/);
const componetsNames: Array<string> = new Array<string>();
window.area = window.location.pathname.split("/")[1];
window.controller = window.location.pathname.split("/")[2];
window.cardName = null;

/*
 * Fetch required modules
 */
requireModule.keys().forEach((fileName) => {
  const url = fileName.replace("./", "");
  componetsNames.push(url);
});

components["HotKeysComponents"] = hotkeys;
components["Autocomplete"] = autocmplete;
components["HeaderComponents"] = header;
components["DocumentComponent"] = document;

/*
 * Register or import current components based on the module json
 */
_.forEach(componetsNames, function (value, key) {
  let componentName = value
    .substring(value.lastIndexOf("/"))
    .replace("/", "")
    .replace(".vue", "");

  // @ts-ignore
  components[componentName + "Component"] = () =>
    import("./../Modules/" + value);
});

/*
 * Component's properties and events
 */
@Component({
  components,
})
export default class DashBoardComponent extends Vue {
  /*
   * The mounted() method gives you access to templates and enables interaction with the DOM.
   */

  mounted() {
    this.$store.dispatch("dashboard/getTemplate", {
      context: this.$store.state.dashboard,
      lang: this.$vuetify.lang,
      self:this
    });
  }

  /*
   *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
   */
  data() {
    // @ts-ignore
    return this.$store.state.dashboard;
  }

  get settings() {
    //#.Checking home page or screen
    if (window.controller && window.area) {
      // @ts-ignore
      this.$store.state.dashboard.renderComponent = true;
    }

    // @ts-ignore
    this.$store.state.dashboard.tabs = this.$store.state.RootApp.menu.tabs;
    // @ts-ignore
    this.$store.state.dashboard.tree = this.$store.state.RootApp.menu.tree;
    // @ts-ignore
    var menus = [];
    this.$store.state.dashboard.tree.forEach((menu) => {
      menus.push(menu.name);
    });

    this.$store.state.dashboard.openNodes = menus; //this.$store.state.RootApp.menu.openNodes;
    // @ts-ignore
    this.$store.state.dashboard.profileClose = this.$store.state.RootApp.profileClose;
    // @ts-ignore
    this.$store.state.dashboard.profileClosePath = this.$store.state.RootApp.profileClosePath || this.$route.fullPath;
    return this.$store.state.dashboard;
  }

  //#. Gets all text for a field of a record according to it's type
  getData(input) {
    return (
      this.$store.state.dashboard.search +
      Utilities.getParameterByName("cId") +
      "/" +
      input
    );
  }

  //#. Gets text for a field of a record according to it's type
  getSearchData(search) {
    this.$store.state.dashboard.extraParams = search.value;
    this.$store.dispatch("removeComponent", JSON.stringify(search.value));
    this.$nextTick(() => {
      //#. Add the component back in
      this.$store.dispatch("renderComponent");
    });
  }

  //#. Dashboard redirect to the main page
  redirectToPreviewPage() {
    //#.Enable notify are triggered with the store.dispatch method.
    this.$store.dispatch("enableNotify", {
      color: "confirm",
      text: this.$store.state.messages.dashboardClose,
      name: "dashboard",
      type: "close",
    });
  }

  //#. Triggered button action with the store.dispatch method.
  getButtonAction(data) {
    //#.Enable mobile button action are triggered with the store.dispatch method.
    this.$store.dispatch("mobileButtonAction", {
      data,
      context: this.$store.state[this.$store.state.dashboard.mobileAppName],
    });
  }

  //#. Triggered mouse over method.
  _dbMouseOver(componentList, index) {
    let context = this.$store.state.dashboard;
    context.componentList = componentList;
    context.selectedComponent = componentList[index];
    context.selectedComponentIndex = index;
    context.selectedTableRowIndex = 0;
    this.settings.hotkeys.enabled = false;
  }

  //#. Triggered mouse leave method.
  _dbMouseLeave() {
    let context = this.$store.state.dashboard;
    this.settings.hotkeys.enabled = false;
    context.selectedTableRowIndex = null;
  }

  appTabClick(moduleName) {
    let state = this.$store.state.dashboard.RootApp;
    //#.Checking of menu permission
    if (state.menu.collection.length > 0) {
      state.menu.tree = [];

      state.menu.collection
        .filter((x) => x.Module == moduleName)
        .forEach((key) => {
          state.menu.tree.push(key);
        });
    }
  }

  /*
   * Router link click event
   */
  _appRouterLink(path) {
    //#.Root context
    let root = this.$store.state.RootApp;
    let rootState = this.$store.state;
    let translate = this.$vuetify.lang;

    root.announcement = false;
    root.profileClosePath = path;

    //#.Clear router history and reset history
    root.routers = [];
    root.routers.push(path);
    localStorage.setItem("routers", JSON.stringify(root.routers));

    //#.Remove extraParams in axios.
    localStorage.setItem("extraParams", "");
    // @ts-ignore
    this.$store.state.dashboard.extraParams = null;

    //#.Static methods for fetch menu id
    let menuId = Utilities.getParameterByName("mId");

    return http.get(root.actions.getTemplates + menuId).then((record) => {
      if (record.data.Result == "OK") {
        // @ts-ignore
        let payload = this.$store.state.dashboard;
        payload.componentId = 0;

        // @ts-ignore
        payload.security = [];
        payload.template = JSON.parse(record.data.Template);
        payload.cards = record.data.Component;
        payload.title = record.data.Caption;
        payload.tooltip = record.data.Tooltip;
        payload.search = record.data.SearchURL;
        payload.searchComponent =
          record.data.SearchName == null ? false : record.data.SearchName;
        payload.breadCrumb = record.data.BreadCrumb;
        payload.close = payload.template.close;
        payload.tabularList = record.data.Tabular;

        //#.Checking enable / disable component close
        if (payload.close) {
          root.profileClose = true;
        } else {
          root.profileClose = false;
        }

        //#.Auto fit template enabled.
        if (payload.template.autofit == true) {
          payload.autoFit = true;
        }

        //#.Tabular form template enabled.
        if (payload.template.tabularform == true) {
          payload.tabularForm = true;
        }

        //#.Check if the component is mobile app
        if (payload.template.mobileApp == true) {
          payload.mobileApp = true;
        }

        //#.Apply translation to messages
        if (payload.keyTranslator) {
          _.forOwn(payload.messages, function (key, val) {
            if (val.indexOf("_") == -1 && !payload.messages["_" + val])
              payload.messages["_" + val] = key;

            if (val.indexOf("_") == -1)
              payload.messages[val] =
                translate.locales[translate.current][
                  payload.messages["_" + val]
                ] || payload.messages["_" + val];
          });
        }

        //#.Update component title
        payload.cards
          .filter((x) => x)
          .forEach((key) => {
            let componentName =
              key.charAt(0).toLowerCase() +
              key.slice(1).replace("Component", "");
            componentName = componentName + "Index";

            //#.Index of the components
            let index = payload.cards.indexOf(key);

            rootState[componentName].card.multiColumn = "Auto";

            if (rootState[componentName])
              rootState[componentName].card.multiColumn = rootState[componentName].multiColumn || "Auto";

            //#.Checking workflow implementation
            if (rootState[componentName].fields.WorkFlowStatusId) {
              rootState[componentName].fields.WorkFlowStatusId.value =
                rootState[componentName].workflow.workflowStepId;
              rootState[componentName].fields.Comments.value =
                rootState[componentName].workflow.workflowComments;
            }

            if (!_.includes(payload.title[payload.cards.indexOf(key)], "{{")) {
              rootState[componentName].title =
                payload.title[payload.cards.indexOf(key)];

              //#.Header list
              let header = [],
                totalFields,
                fieldsList = [];
              rootState[componentName].landscape = true;

              // @ts-ignore
              _.forOwn(rootState[componentName].fields, function (key, val) {
                if (
                  key.primaryKey != true &&
                  key.parent != true &&
                  key.list != false &&
                  key.type != "Hidden"
                ) {
                  if (!key.orgTitle) key.orgTitle = key.title;

                  if (payload.keyTranslator)
                    key.text =
                      translate.locales[translate.current][key.title] ||
                      key.title;
                  else key.text = key.title;

                  key.title = key.text;
                  // @ts-ignore
                  header.push(key);
                }

                if (
                  !key.primaryKey &&
                  key.type != "Hidden" &&
                  !key.create &&
                  !key.parent
                ) {
                  // @ts-ignore
                  fieldsList.push(key.value);
                }
              });

              rootState[componentName].headers = header;

              if (
                rootState[componentName].card.type !=
                rootState[componentName].type._tree
              ) {
                totalFields = fieldsList.length;

                //Auto arrange the field layout
                if (rootState[componentName].multiColumn == "Auto") {
                  if (totalFields >= 1 && totalFields <= 6) {
                    rootState[componentName].card.multiColumn = 1;
                  } else if (totalFields >= 7 && totalFields <= 12) {
                    rootState[componentName].card.multiColumn = 2;
                  } else if (totalFields >= 12 && totalFields <= 18) {
                    rootState[componentName].card.multiColumn = 3;
                  } else {
                    rootState[componentName].card.multiColumn = 4;
                  }

                  rootState[componentName].multiColumn =
                    rootState[componentName].card.multiColumn;
                } else {
                  rootState[componentName].card.multiColumn =
                    rootState[componentName].multiColumn;
                }

                if (rootState[componentName].multiColumn > 2) {
                  rootState[componentName].landscape = false;
                }

                if (rootState[componentName].inlineEditor.enabled) {
                  rootState[componentName].landscape = false;
                }
              }
            } else {
              rootState[componentName].titleSearch = true;
              let title = payload.title[index].substr(2).slice(0, -2);
              rootState[componentName].headerTooltip =
                rootState[componentName].fields[title].title;
            }
          });

        payload.renderComponent = false;

        Vue.nextTick(() => {
          // @ts-ignore
          payload.renderComponent = true;
        });
      }
    });
  }

  _appCloseBtn() {
    //#.Root context
    let context = this.$store.state.dashboard;
    let root = this.$store.state.RootApp;
    let rootState = this.$store.state;
    let translate = this.$vuetify.lang;
    let isDirty = false;

    if (context) {
      _.forOwn(context.cards, function (key, val) {
          let componentName = camelcase(key).replace('Component', '');
          componentName = componentName + 'Index';

          if (rootState[componentName] && rootState[componentName].isDirty) {
              isDirty = true;
              return;
          }
      });
    }

    if (isDirty) {
      //#.Enable notify are triggered with the store.dispatch method.
      this.$store.dispatch('dashboard/enableNotify', { color: 'confirm', text: context.messages.dashboardClose, name: "dashboard", type: 'dashboardClose' });
    } else {
      this.$store.dispatch('dashboard/appClose', { self: this });
    }
  }
}
